import { useState } from 'react'
import {
    AccountRecord,
    useRefreshMessengerConversationsMutation,
    useToggleDmsMutation
} from '../../api/client'
import Toggle from './Toggle'
import Button from '../../components/Button'
import { toastError, toastSuccess } from '../../components/Notification'

type Props = {
    account: AccountRecord
}

const DmsToggle = ({ account }: Props) => {
    const [toggleDmsMutation, { loading: toggling }] = useToggleDmsMutation()
    const [refreshMessengerConversations, { loading: refreshing }] =
        useRefreshMessengerConversationsMutation()
    const [enabled, setEnabled] = useState(account.dmsEnabled)

    const onToggle = async (isEnabled: boolean) => {
        await toggleDmsMutation({
            variables: {
                accountId: Number(account.id),
                enabled: isEnabled
            },
            onCompleted: async (result) => {
                setEnabled(isEnabled)
            },
            onError: (err) => {
                console.error(err)
                toastError('Unable toggle DMs. See console for details.')
            }
        })
    }

    const onFetchConversations = async () => {
        await refreshMessengerConversations({
            variables: { accountId: Number(account.id) },
            onCompleted: async (result) => {
                let total_fetched = result.refreshMessengerConversations.length
                toastSuccess(`Fetched ${total_fetched} conversations`)
            },
            onError: (err) => {
                console.error(err)
                toastError('Unable to fetch conversations. See console for details.')
            }
        })
    }

    return (
        <div className="flex items-center gap-3">
            <Toggle
                id="DmsToggle"
                disabled={false}
                checked={enabled}
                onToggle={onToggle}
                label="Direct messages"
                loading={toggling}
                tooltip="Enable Direct Messages feature for this account."
                data-cy="dms_toggle"
                size="large"
            />
            <Button
                primary={false}
                disabled={!enabled || refreshing}
                onClick={onFetchConversations}
                text={refreshing ? 'Fetching…' : 'Fetch conversations'}
            />
        </div>
    )
}

export default DmsToggle
